<template>
  <div>
    <nav-bar />
    <set-setting
      :setting="setting"
      @close="setting = undefined"
      @success="getSettings"
    />
    <b-container>
      <b-row>
        <b-col>
          <v-card>
            <v-card-title>
              <b-row align-v="center">
                <b-col cols="auto">
                  <v-btn
                    class="v-primary"
                    @click="$bvModal.show('set_setting')"
                  >
                    <i class="fa fa-plus mr-1" /> Nova
                  </v-btn>
                </b-col>
                <b-col cols="auto"> Configurações </b-col>
                <b-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    outlined
                    dense
                    hide-details
                  />
                </b-col>
              </b-row>
            </v-card-title>
            <v-card-text>
              <b-overlay :show="loading" opacity="0.99">
                <b-row>
                  <b-col> </b-col>
                </b-row>
                <div class="col">
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="settings"
                    :search="search"
                    :footer-props="{
                      'items-per-page-options': [25, 75, 100],
                      'items-per-page-text': 'Mostrar',
                    }"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-btn color="primary" @click="setting = item">
                        EDITAR
                      </v-btn>
                    </template>
                  </v-data-table>
                  <ErrorsMessages :errors="errors" />
                </div>
              </b-overlay>
            </v-card-text>
          </v-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import SetSetting from "../templates/settings/set-setting.vue";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import api from "../services/api";

export default {
  name: "SecurityQuestions",
  components: {
    NavBar,
    ErrorsMessages,
    SetSetting,
  },

  data() {
    return {
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Valor", value: "value" },
        { text: "Ações", value: "actions" },
      ],
      settings: [],
      setting: null,
    };
  },

  created() {
    this.getSettings();
  },

  methods: {
    async getSettings() {
      try {
        this.loading = true;

        const response = await api.get("/settings");
        const { error, errors, settings } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.settings = settings;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>